import * as React from "react";

const Notifications = () => {

  return (
    <div className="container mx-auto p-4  py-24">
      <h1 className="text-2xl font-bold mb-4 text-center w-full ">
        Notifications
      </h1>
    </div>
  );
};

export default Notifications;
